import ReportsData from "./ReportsData";
import { useTranslation } from "react-i18next";
const ReportsOverviewTable = () => {
    const { t } = useTranslation();
    //console.log(userId);
    const { data, loading, error } = ReportsData();

    // Define the table headers
    const columns = [
      { Header: t("trajectories.wizard.reports.columns.index"), accessor: "id" },
      { Header: t("trajectories.wizard.reports.columns.name"), accessor: "name" },
      { Header: t("trajectories.wizard.reports.columns.userId"), accessor: "userId" },
      { Header: t("trajectories.wizard.reports.columns.createdDate"), accessor: "createdDate" },
    ];

    const unknown = t("trajectories.wizard.reports.unknown");
    let showData = [];

    showData = data;


    const rows = showData.map((item, index) => ({
      id: index +1 ?? unknown,
      primaryWayId: item.primaryWayId ?? unknown,
      name: item.name ?? unknown,
      createdDate: item.createdDate ?? unknown,
      userId: item.userId ?? unknown,
      reportId:item.id ?? unknown,
      reportName:item.name ?? unknown
    }));
  
    // Return the table-ready data
    return {
      tableData: { columns, rows },
      loading,
      error,
    };
  };
  
  export default ReportsOverviewTable;
  